module.exports = __webpack_public_path__ + "4e0c588db2a2b910b8689c3a587f9252.png";